/* eslint-disable indent */
import React from "react";
import { object, string, bool } from "prop-types";
import { Row, Col } from "react-bootstrap";
import DOMPurify from "dompurify";
import {
  getDefaultEmailSubject,
  getDefaultEmailSender,
  getDefaultEmailBody,
} from "./defaultEmailTemplateHelpers";

const EmailPreviewBox = ({
  companyName,
  defaultEmailTemplateType,
  emailToPreview,
  isInsightUser,
  proctoring,
  showProctoring,
}) => {
  // Set up email variables to be used in email preview
  const emailBody = {
    __html: DOMPurify.sanitize(
      emailToPreview
        ? emailToPreview.get("emailBody")
        : getDefaultEmailBody(
            isInsightUser,
            defaultEmailTemplateType,
            companyName,
            showProctoring && proctoring
          )
    ),
  };

  const emailSubject = emailToPreview
    ? emailToPreview.get("emailSubject")
    : getDefaultEmailSubject(
        isInsightUser,
        defaultEmailTemplateType,
        companyName
      );

  const senderAlias = emailToPreview
    ? emailToPreview.get("senderAlias")
    : getDefaultEmailSender(isInsightUser);

  return (
    <Row className="mb-2">
      <Col lg={12} md={12} sm={12} style={{ paddingTop: "20px" }}>
        <div className="emailPreviewBox">
          <p>{senderAlias}</p>
          <p>{emailSubject}</p>
          <hr />
          <div // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={emailBody}
          />
        </div>
      </Col>
    </Row>
  );
};

EmailPreviewBox.propTypes = {
  companyName: string,
  defaultEmailTemplateType: string,
  emailToPreview: object,
  isInsightUser: bool,
  proctoring: bool,
  showProctoring: bool,
};

export default EmailPreviewBox;
